import React, { useState } from "react";

import icon1Disabled from "images/smiles/dissapointed_1.svg";
import icon2Disabled from "images/smiles/sad_1.svg";
import icon3Disabled from "images/smiles/neutral_1.svg";
import icon4Disabled from "images/smiles/liked_1.svg";
import icon5Disabled from "images/smiles/happy_1.svg";

import icon1Active from "images/smiles/dissapointed_2.svg";
import icon2Active from "images/smiles/sad_2.svg";
import icon3Active from "images/smiles/neutral_2.svg";
import icon4Active from "images/smiles/liked_2.svg";
import icon5Active from "images/smiles/happy_2.svg";

export default function Emoji({ selectedPosition, setRate }) {
  const [isIcon1Active, setIcon1Active] = useState(false);
  const [isIcon2Active, setIcon2Active] = useState(false);
  const [isIcon3Active, setIcon3Active] = useState(false);
  const [isIcon4Active, setIcon4Active] = useState(false);
  const [isIcon5Active, setIcon5Active] = useState(false);

  const icon1 =
    isIcon1Active || selectedPosition == 1 ? icon1Active : icon1Disabled;
  const icon2 =
    isIcon2Active || selectedPosition == 2 ? icon2Active : icon2Disabled;
  const icon3 =
    isIcon3Active || selectedPosition == 3 ? icon3Active : icon3Disabled;
  const icon4 =
    isIcon4Active || selectedPosition == 4 ? icon4Active : icon4Disabled;
  const icon5 =
    isIcon5Active || selectedPosition == 5 ? icon5Active : icon5Disabled;

  return (
    <div className="text-center smiles set-rates">
      <img
        src={icon1}
        onMouseEnter={() => setIcon1Active(true)}
        onMouseLeave={() => setIcon1Active(false)}
        onClick={() => setRate(1)}
      />
      <img
        src={icon2}
        onMouseEnter={() => setIcon2Active(true)}
        onMouseLeave={() => setIcon2Active(false)}
        onClick={() => setRate(2)}
      />
      <img
        src={icon3}
        onMouseEnter={() => setIcon3Active(true)}
        onMouseLeave={() => setIcon3Active(false)}
        onClick={() => setRate(3)}
      />
      <img
        src={icon4}
        onMouseEnter={() => setIcon4Active(true)}
        onMouseLeave={() => setIcon4Active(false)}
        onClick={() => setRate(4)}
      />
      <img
        src={icon5}
        onMouseEnter={() => setIcon5Active(true)}
        onMouseLeave={() => setIcon5Active(false)}
        onClick={() => setRate(5)}
      />
    </div>
  );
}
